import type { SplitCostingRow } from "./parseSplitCostingCsv";
import { SPLIT_COSTING_PATH_FIELD_LABELS } from "./splitCostingRowValidation";

const REQUIRED_PATH_LEVELS = 3;

export interface SplitCostingPathColumn {
  level: number;
  label: (typeof SPLIT_COSTING_PATH_FIELD_LABELS)[number];
}

function pathCode(
  row: SplitCostingRow | undefined,
  level: number
): string | null {
  const code = row?.path.find((part) => part.level === level)?.code.trim();
  return code ? code : null;
}

export function getVisibleSplitCostingPathColumns(
  rows: readonly SplitCostingRow[]
): SplitCostingPathColumn[] {
  return SPLIT_COSTING_PATH_FIELD_LABELS.map((label, index) => ({
    level: index + 1,
    label,
  })).filter(
    ({ level }) =>
      level <= REQUIRED_PATH_LEVELS ||
      rows.some((row) => pathCode(row, level) !== null)
  );
}

export function formatSplitCostingPathCode(
  row: SplitCostingRow | undefined,
  level: number
): string {
  return pathCode(row, level) ?? "—";
}
